import React from 'react';

import type { AIDefinitionsPluginInjectionAPI } from '../aiDefinitionsPluginType';

import { getAIDefinitionsErrorAnalyticsPayload } from './utils/analytics';

interface AIDefinitionsErrorBoundaryProps {
	api: AIDefinitionsPluginInjectionAPI;
	children: React.ReactNode;
}

interface AIDefinitionsErrorBoundaryState {
	hasError: boolean;
}

// eslint-disable-next-line @repo/internal/react/no-class-components
export class AIDefinitionsErrorBoundary extends React.Component<
	AIDefinitionsErrorBoundaryProps,
	AIDefinitionsErrorBoundaryState
> {
	state = { hasError: false };

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
		this.props.api?.analytics?.actions.fireAnalyticsEvent(
			getAIDefinitionsErrorAnalyticsPayload({ error, errorInfo }),
		);
	}

	render(): React.ReactNode {
		if (this.state.hasError) {
			return null;
		}

		return this.props.children;
	}
}
